__turbopack_context__.v({
  "header": "ShortNewsArticlesLinks-module-scss-module__jUaYJq__header",
  "listItem": "ShortNewsArticlesLinks-module-scss-module__jUaYJq__listItem",
  "title": "ShortNewsArticlesLinks-module-scss-module__jUaYJq__title",
});
